import axios from "axios";
import CONSTANT from "./constant";
import { config } from "../config";
import { setUser } from "../store/authSlice";
import APIService from "../services/API";

axios.defaults.baseURL = config.apiServerUrl;
axios.defaults.headers.common["Content-Type"] = "application/json";

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Lỗi "bị xóa khỏi nhóm chat" tuy trả 403 nhưng KHÔNG được đăng xuất user;
    // để caller (màn hình chat) tự xử lý đồng bộ giao diện.
    if (
      error.response?.data?.code ===
      CONSTANT.ERROR_CODE.CHAT_GROUP_MEMBER_REMOVED
    ) {
      return Promise.reject(error);
    }
    if (
      error.response &&
      (error.response.status === 401 ||
        error.response.status === 403 ||
        error.response.status === 406)
    ) {
      if (!window.location.href.includes("/logout")) {
        window.location.href = "/logout";
      } else {
        return Promise.reject(error);
      }
    } else {
      return Promise.reject(error);
    }
  }
);

export function initUserFromStorage() {
  return (dispatch: any) => {
    const user = getUserStorage();
    if (!user) {
      return;
    }

    // BƯỚC 1 — dựng lại phiên từ localStorage NGAY LẬP TỨC. Không chờ máy chủ ở bước
    // dưới, nếu không màn hình sẽ chớp sang trang đăng nhập mỗi lần tải lại trang.
    if (user.token) {
      setAxiosHeaders(user.token);
    }
    dispatch(setUser(user));

    // BƯỚC 2 — hỏi lại máy chủ để lấy hồ sơ MỚI NHẤT (giống initUserFromStorage của
    // phần mềm VIC, xem frontend/src/store/user/actions.ts).
    //
    // Bản nằm trong localStorage là ẢNH CHỤP lúc đăng nhập: quyền trong system_roles,
    // họ tên, ảnh đại diện... sửa bên phần mềm VIC sẽ không tới được webchat cho tới
    // khi người dùng tự đăng xuất rồi đăng nhập lại. Riêng quyền thì đây là chuyện
    // thật sự phiền: gỡ quyền cho ai đó mà tab webchat của họ đang mở thì nút gác theo
    // quyền (TRA CỨU HÓA ĐƠN...) vẫn hiện nguyên.
    //
    // `/auth/profile` trả về kèm cả token nên setUser giữ nguyên phiên đăng nhập.
    // Token hỏng/hết hạn thì endpoint trả 401 và interceptor phía trên tự đẩy sang
    // /logout — đúng thứ cần xảy ra, nên ở đây chỉ ghi log rồi thôi: lỗi mạng một
    // nhịp không được phép đá người dùng ra khỏi phiên đang dùng được.
    if (user.token) {
      APIService.getUserProfile(user.token)
        .then((res: any) => {
          if (res.success) {
            dispatch(setUser(res.data));
          }
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  };
}

export const setAxiosHeaders = (token: string) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const getUserStorage = () => {
  if (localStorage.getItem(CONSTANT.STORAGE_KEY.DRIVER_USER)) {
    const user = JSON.parse(
      localStorage.getItem(CONSTANT.STORAGE_KEY.DRIVER_USER) || "{}"
    );
    return user.user;
  }

  return undefined;
};

export const setUserStorage = (newUser: any) => {
  if (newUser && newUser.token) {
    const userStorage = {
      user: newUser,
    };

    localStorage.setItem(
      CONSTANT.STORAGE_KEY.DRIVER_USER,
      JSON.stringify(userStorage)
    );
  } else {
    localStorage.removeItem(CONSTANT.STORAGE_KEY.DRIVER_USER);
  }
};
